import { HelperText } from "../elements/HelperText";
import { Stack } from "@mui/material";
import { FormLabel } from "../elements/FormLabel";
import ImageUploader from "./ImageUploader";

export const FileUploader = ({
  label,
  helperText,
  images,
  setImages,
  limit,
  size,
  required = false,
  ...props
}) => (
  <Stack spacing={1}>
    <FormLabel required={required} {...props}>
      {label}
    </FormLabel>
    <ImageUploader
      images={images}
      setImages={setImages}
      limit={limit}
      size={size}
    />
    <HelperText text={helperText} />
  </Stack>
);
